import React from 'react';
import * as $ from 'jquery';
import { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import 'daterangepicker';
import 'daterangepicker/daterangepicker.css';
import styles from '../MileageSarathiTab_bus/MileageSaarathi.module.css';

export default function Filter_Analysis(props) {
  const { justifyContent } = props
  const [filterdata, setFilterData] = useState({ ...props.globalfilter });

  useEffect(() => {
    setFilterData({ ...props.globalfilter })
  }, [props.globalfilter])

  const inputRef = useRef(null);

  const formatDateForDisplay = (date) => {
    return date ? moment(date).format('MMM D, YYYY') : '';
  };

  useEffect(() => {
    if (filterdata.startDate) {
      const today = moment();
      const fiveYearsAgo = moment().subtract(5, 'years');
      const defaultStart = moment(filterdata.startDate);
      const defaultEnd = moment(filterdata.endDate);

      $(inputRef.current).daterangepicker(
        {
          startDate: defaultStart,
          endDate: defaultEnd,
          minDate: fiveYearsAgo,
          maxDate: today,
          showDropdowns: true,
          autoUpdateInput: false,
          singleMonthMode: true,
          linkedCalendars: false,
          locale: {
            format: 'MMMM D, YYYY',
            applyLabel: 'Apply',
            separator: ' - ',
            cancelLabel: '',
          },
        }
      );

      // Handle 'Apply' button click
      $(inputRef.current).on('apply.daterangepicker', function (ev, picker) {
        const start = picker.startDate.format("YYYY-MM-DD");
        const end = picker.endDate.format("YYYY-MM-DD");

        $(this).val(
          picker.startDate.format('MMMM D, YYYY') + ' - ' + picker.endDate.format('MMMM D, YYYY')
        );

        setFilterData(prev => ({
          ...prev,
          startDate: start,
          endDate: end,
        }));
        props.onsubmit(prev => ({
          ...prev,
          startDate: start,
          endDate: end,
        }));
      });

      // Clear input on cancel
      $(inputRef.current).on('cancel.daterangepicker', function () {
        $(this).val('');
        setFilterData(prev => ({
          ...prev,
          startDate: null,
          endDate: null,
        }));
      });
    }

    return () => {
      if ($(inputRef.current).data('daterangepicker')) {
        $(inputRef.current).data('daterangepicker').remove();
        $(inputRef.current).off('.daterangepicker');
      }
    };
  }, []);



  return (
    <>
      <div className="card mb-3 p-3">
        <div className={`row ${justifyContent}`}> {/* aligns children to the right */}
          <div className="col-md-4 text-left"> {/* right-aligns text inside column */}
            <div className={`mb-1 me-auto ${styles.date_range_selection}`}>Date Range</div>
            <div className="input-group mt-1 justify-content-end"> {/* align input group right */}
              <input
                type="text"
                ref={inputRef}
                className={`form-control ${styles.customDateRangePicker}`}
                placeholder="Select date range"
                value={
                  filterdata.startDate && filterdata.endDate
                    ? `${formatDateForDisplay(filterdata.startDate)} - ${formatDateForDisplay(filterdata.endDate)}`
                    : ''
                }
                readOnly
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}